import axios from '../lib/axios';

// Evict the current user's server-side permission cache (plain + impersonation keys)
// so a relogin fetches fresh permissions.
export async function evictPermissionsCache(): Promise<void> {
  await axios.post('/api/permissions/refresh');
}
